// smartMart.videowise-related.js
// last updates: events debug
// version: 20260907-
document.addEventListener('DOMContentLoaded', (e) => {
	window.smartMart_videowiseRelated = window.smartMart_stikyACTrelated || {};
	smartMart_videowiseRelated.hdr= '[smartMart_videowiseRelated]:';
	smartMart_videowiseRelated.version = '0.1.1_b';

	// listen events ATC:
	window.addEventListener('videowiseProductAddToCart', (e) => {
		// update Cart icon/CartDrawer, log
		document.dispatchEvent(new CustomEvent('cart:build'));
		console.log(`${smartMart_videowiseRelated.hdr} Theme CartDrawer updated on window ${e.type}`);
	});

	// log done
	console.log(`${smartMart_videowiseRelated.hdr} ${smartMart_videowiseRelated.version} done`);
});
